var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMoreabout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.4H10.6C11.0243 15.4 11.4313 15.2314 11.7314 14.9314C12.0314 14.6313 12.2 14.2243 12.2 13.8V6.1312C12.2 5.91904 12.1156 5.71559 11.9656 5.5656L7.6344 1.2344C7.48441 1.08436 7.28096 1.00005 7.0688 1H2.6C2.17565 1 1.76869 1.16857 1.46863 1.46863C1.16857 1.76869 1 2.17565 1 2.6V11.4M1 15.4L4.9032 11.4968M4.9032 11.4968C5.12537 11.7227 5.39005 11.9023 5.68199 12.0254C5.97393 12.1484 6.28735 12.2125 6.60416 12.2138C6.92098 12.2151 7.23492 12.1537 7.52788 12.0331C7.82084 11.9125 8.08702 11.7351 8.31107 11.5111C8.53512 11.2871 8.71261 11.0209 8.83329 10.728C8.95396 10.4351 9.01545 10.1211 9.0142 9.80433C9.01295 9.48752 8.94898 9.17409 8.82599 8.88212C8.703 8.59015 8.52341 8.32542 8.2976 8.1032C7.84633 7.65911 7.23786 7.41134 6.60473 7.41384C5.9716 7.41634 5.36511 7.66892 4.91736 8.11656C4.46961 8.56421 4.21689 9.17064 4.21424 9.80377C4.21159 10.4369 4.45922 11.0454 4.9032 11.4968Z",
    stroke: "#545454",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoreabout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/moreabout.9df76e58.svg";
export { ForwardRef as ReactComponent };